import { jsx as e, jsxs as v, Fragment as c } from "@emotion/react/jsx-runtime";
import { useState as d } from "react";
import { InnerPreviewContainer as h, Overlay as f, ActionThumbContainer as m, StyledIconButton as u } from "./InnerPreview.styled.js";
const I = ({
  removeFile: t,
  actionThumb: a,
  children: l,
  isSingleFullPhoto: s
}) => {
  const [r, n] = d(!1), i = (o) => {
    o.stopPropagation(), t(), n(!1);
  };
  return /* @__PURE__ */ e(h, { onMouseEnter: () => n(!0), onMouseLeave: () => n(!1), children: /* @__PURE__ */ v(c, { children: [
    l,
    r && /* @__PURE__ */ e(f, { justifyContent: "flex-start", alignItems: "flex-end", children: /* @__PURE__ */ e(m, { children: a }) }),
    (s || r) && /* @__PURE__ */ e(u, { dataTrackId: "remove-file-preview", "aria-label": "Remove file", icon: ["fa-trash"], onClick: (o) => i(o), variant: "danger" })
  ] }) });
};
export {
  I as InnerPreview
};
